module.exports = __webpack_public_path__ + "img/cover.19fe3522.jpg";